<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
      <app-back-button *ngIf="!loading && !showAdFlow"></app-back-button>
      <div class="page-header">
        <h1 class="page-title">{{ 'convert.title' | t }}</h1>
        <p class="subtitle">{{ 'convert.subtitle' | t }}</p>
      </div>

          <div class="glass-card convert-card">
            <form [formGroup]="form" (ngSubmit)="submit()">
              <div class="platforms">
                <div>
            <label>{{ 'convert.source' | t }}</label>
            <ion-segment mode="md" class="platform-segment glass-card" formControlName="sourcePlatform" value="spotify">
              <ion-segment-button value="spotify" layout="icon-start">
                <ion-icon src="/assets/icons/spotify.svg" class="platform-icon" aria-hidden="true"></ion-icon>
                <ion-label>Spotify</ion-label>
              </ion-segment-button>
              <ion-segment-button value="youtube" layout="icon-start">
                <img src="/assets/yt_icon_red_digital.png" class="platform-icon platform-icon--yt" alt="YouTube" />
                <ion-label>YouTube</ion-label>
              </ion-segment-button>
            </ion-segment>
          </div>
          <div>
            <label>{{ 'convert.target' | t }}</label>
            <ion-segment mode="md" class="platform-segment glass-card" formControlName="targetPlatform" value="youtube">
              <ion-segment-button value="spotify" layout="icon-start">
                <ion-icon src="/assets/icons/spotify.svg" class="platform-icon" aria-hidden="true"></ion-icon>
                <ion-label>Spotify</ion-label>
              </ion-segment-button>
              <ion-segment-button value="youtube" layout="icon-start">
                <img src="/assets/yt_icon_red_digital.png" class="platform-icon platform-icon--yt" alt="YouTube" />
                <ion-label>YouTube</ion-label>
              </ion-segment-button>
            </ion-segment>
          </div>
              </div>

        <ion-item lines="none" class="glass-input">
          <ion-input [label]="'convert.url.label' | t" labelPlacement="floating" formControlName="playlistUrl" [placeholder]="'convert.url.placeholder' | t"></ion-input>
        </ion-item>
        <div class="tos-note">
          By using Tubify, you agree to our
          <a routerLink="/terms">Terms of Service</a>
          and
          <a routerLink="/privacy">Privacy Policy</a>.
        </div>
        <div class="form-footer">
          <div class="left-controls">
            <div class="mode-switch-mini">
              <div class="toggle-row">
                <span class="mini-label eco" [class.active]="form.get('mode')?.value === 'ECO'">ECO</span>
                <ion-toggle mode="ios"
                            [checked]="form.get('mode')?.value === 'FULL'"
                            (ionChange)="setMode($event.detail.checked ? 'FULL' : 'ECO')"
                            class="mode-toggle-small"
                            [class.full]="form.get('mode')?.value === 'FULL'"
                            [class.eco]="form.get('mode')?.value === 'ECO'"></ion-toggle>
                <span class="mini-label full" [class.active]="form.get('mode')?.value === 'FULL'">FULL</span>
              </div>
              <div class="switch-note-row">
                <div class="switch-note">{{ form.get('mode')?.value === 'ECO' ? ('convert.mode.ecoCopy' | t) : ('convert.mode.fullCopy' | t) }}</div>
                <a class="token-help-icon" routerLink="/app/tokens" aria-label="¿Qué son los tokens?">?</a>
              </div>
            </div>
          </div>
          <div class="actions">
            <ion-button type="submit" class="futuristic-button" [disabled]="loading">
              {{ 'convert.submit' | t }}
            </ion-button>
          </div>
        </div>
      </form>
          </div>

          <div *ngIf="showAdFlow || loading" class="glass-card ad-flow">
            <div *ngIf="showAdFlow" class="ad-video">
          <div class="ad-overlay" *ngIf="!adDone">
            <div class="timer">{{ adCountdown }}s</div>
            <div class="message">{{ 'convert.ad.timer' | t }}</div>
            <div class="message subtle">{{ 'convert.ad.note' | t }}</div>
          </div>
          <div class="post-ad" *ngIf="adDone && !conversionFinished">
            <div class="looping-orbit"></div>
            <div class="message subtle">{{ 'convert.postad' | t }}</div>
          </div>
          <div class="final" *ngIf="finalAnimationVisible">
            <div class="animated-check"></div>
            <div class="message">{{ 'convert.done' | t }}</div>
          </div>
        </div>

        <div *ngIf="!showAdFlow" class="standard-loading" [class.done]="finalAnimationVisible">
          <ion-spinner *ngIf="!finalAnimationVisible"></ion-spinner>
          <div class="animated-check" *ngIf="finalAnimationVisible"></div>
          <div class="message">{{ finalAnimationVisible ? ('convert.done' | t) : ('convert.ad.timer' | t) }}</div>
        </div>
      </div>

      <div *ngIf="conversion" class="glass-card result-card fade-slide-enter">
        <div class="result-header">
          <div>
            <div class="subtitle">{{ 'convert.results.status' | t }}: {{ conversion.status }}</div>
            <h2>{{ conversion.sourceTitle || (conversion.sourcePlatform | titlecase) }} → {{ conversion.targetTitle || (conversion.targetPlatform | titlecase) }}</h2>
            <p class="subtitle" *ngIf="conversion.sourceTrackCount">{{ 'convert.results.tracks' | t }}: {{ conversion.sourceTrackCount }}</p>
            <p class="subtitle" *ngIf="conversion.mode">{{ 'convert.results.mode' | t }}: {{ conversion.mode }}</p>
            <p class="subtitle note" *ngIf="conversion.mode === 'ECO'">{{ 'convert.results.ecoNote' | t }}</p>
          </div>
          <a *ngIf="conversion.targetPlaylistUrl" [href]="conversion.targetPlaylistUrl" target="_blank" rel="noopener" class="futuristic-chip">
            {{ 'convert.results.openTarget' | t }}
          </a>
        </div>

        <ion-progress-bar [value]="progressPercent() / 100" [color]="conversion.status === 'FAILED' ? 'danger' : 'primary'"></ion-progress-bar>
        <div class="progress-row">
          <div>{{ progressPercent() }}% • {{ conversion.processedCount || 0 }}/{{ conversion.total || '?' }} tracks</div>
          <div *ngIf="conversion.status === 'FAILED'" class="error-text">{{ conversion.errorMessage || 'Conversion failed' }}</div>
          <div *ngIf="conversion.current && conversion.status !== 'FAILED'" class="current">
            Now: {{ conversion.current.sourceTrack?.title }}
          </div>
        </div>

        <div class="results-grid">
          <div>
            <h3>Added</h3>
            <ion-list>
              <ion-item *ngFor="let item of (conversion.added || [])">
                <ion-label>
                  <div class="track-title">{{ item.sourceTrack.title }}</div>
                  <div class="subtitle">{{ item.matchedTarget?.title || '—' }}</div>
                </ion-label>
                <ion-badge [color]="confidenceColor(item.confidenceLevel)">{{ item.confidenceLevel }}</ion-badge>
                <div class="score">{{ (item.matchScore || 0) * 100 | number: '1.0-0' }}%</div>
                <div class="rematch">
                  <ion-button size="small" fill="clear" class="rematch-button"
                              [disabled]="conversion?.status !== 'COMPLETED' || rematchStateFor(item?.sourceTrack?.spotifyId || item?.sourceTrack?.youtubeId) === 'loading' || tokens?.remaining === 0"
                              (click)="requestRematch(item)">
                    Rematch
                  </ion-button>
                  <span class="rematch-status error"
                        *ngIf="rematchStateFor(item?.sourceTrack?.spotifyId || item?.sourceTrack?.youtubeId) === 'error'">
                    failed
                  </span>
                </div>
              </ion-item>
              <ion-item *ngIf="!conversion.added?.length">
                <ion-label>No tracks added yet.</ion-label>
              </ion-item>
            </ion-list>
          </div>
          <div>
            <h3>Skipped</h3>
            <ion-list>
              <ion-item *ngFor="let item of (conversion.skipped || [])">
                <ion-label>
                  <div class="track-title">{{ item.sourceTrack.title }}</div>
                  <div class="subtitle">No confident match</div>
                </ion-label>
                <div class="rematch">
                  <ion-button size="small" fill="clear" class="rematch-button"
                              [disabled]="conversion?.status !== 'COMPLETED' || rematchStateFor(item?.sourceTrack?.spotifyId || item?.sourceTrack?.youtubeId) === 'loading' || tokens?.remaining === 0"
                              (click)="requestRematch(item)">
                    Rematch
                  </ion-button>
                  <span class="rematch-status error"
                        *ngIf="rematchStateFor(item?.sourceTrack?.spotifyId || item?.sourceTrack?.youtubeId) === 'error'">
                    failed
                  </span>
                </div>
              </ion-item>
              <ion-item *ngIf="!conversion.skipped?.length">
                <ion-label>No skipped tracks.</ion-label>
              </ion-item>
            </ion-list>
          </div>
        </div>
      </div>

      <div class="error-card glass-card" *ngIf="error && !conversion">
        {{ error }}
      </div>

      <div class="ad-out">
        <app-ad-slot placement="convert"></app-ad-slot>
      </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
